import styled from '@emotion/styled';
import { themeGet } from '@styled-system/theme-get';

export const StyledLinks = styled.div`
  display: grid;
  grid-row-gap: ${themeGet('scale.scaleUp03')};

  span:last-of-type {
    ${themeGet('font.whitneyBook')}
    display: block;
    margin-top: ${themeGet('scale.scaleDown03')};
    font-size: ${themeGet('scale.scaleDown01')};
    text-decoration: none;
  }

  a:not(.arrow-link) {
    display: block;

    &:hover {
      text-decoration: none;

      span:first-of-type {
        text-decoration: underline;
      }
    }
  }

  @media (min-width: ${themeGet('breakpoint.breakpointMobile')}) {
    grid-template-columns: repeat(2, 1fr);
    grid-column-gap: ${themeGet('scale.scaleUp07')};
    grid-template-rows: repeat(2, minmax(0, auto));
    grid-auto-flow: column;
  }

  @media (min-width: ${themeGet('breakpoint.breakpointNavMd')}) {
    grid-column-gap: ${themeGet('scale.scaleUp03')};
  }
`;

export default StyledLinks;
